export default {
  en: {
    search: "Search",
    obtain: "Obtain",
    contactUs: "Contact Us",
    // Header导航
    nav: {
      home: "Home",
      solutions: "Solutions",
      cases: "Cases",
      contact: "Contact Us",
    },
    // 语言选择器
    language: {
      selectLanguage: "Select Language",
      chinese: "Chinese",
      english: "English",
    },
    // Footer
    footer: {
      solutions: "Solutions",
      contactUs: "Contact Us",
      helpDocs: "Help Documents",
      blog: "Blog",
      copyright:
        "Copyright © 2025 Eclick Network Technology Co., Ltd. All rights reserved",
      privacyPolicy: "Privacy Policy",
      backToTop: "Back to Top",
      emailUs: "Or email us at:",
    },
  },
  zh: {
    search: "查询",
    obtain: "获取",
    contactUs: "联系我们",
    // Header导航
    nav: {
      home: "首页",
      solutions: "解决方案",
      cases: "客户案例",
      contact: "联系我们",
    },
    // 语言选择器
    language: {
      selectLanguage: "选择语言 / Select Language",
      chinese: "中文",
      english: "English",
    },
    // Footer
    footer: {
      solutions: "解决方案",
      contactUs: "联系我们",
      helpDocs: "帮助文档",
      blog: "博客",
      copyright: "Copyright © 2025 易点天下网络科技股份有限公司 版权所有",
      privacyPolicy: "隐私政策",
      backToTop: "返回顶部",
      emailUs: "Or email us at:",
    },
  },
};
